import { useEffect, useMemo, useState } from 'react';
import { Keyboard, KeyboardEvent } from 'react-native';

interface KeyboardState {
  visible: boolean;
  height: number;
}

export function useKeyboard(): KeyboardState {
  const [visible, setVisible] = useState(false);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const keyboardDidShowListener = Keyboard.addListener(
      'keyboardDidShow',
      (_event: KeyboardEvent) => {
        setVisible(true);
        setHeight(0);
      },
    );
    const keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', () => {
      setVisible(false);
      setHeight(0);
    });
    return () => {
      keyboardDidShowListener.remove();
      keyboardDidHideListener.remove();
    };
  }, []);

  return useMemo(() => ({ visible, height }), [visible, height]);
}

export function useKeyboardHeight(): number {
  const { height } = useKeyboard();
  return height;
}

export function useKeyboardVisible(): boolean {
  const { visible } = useKeyboard();
  return visible;
}
